"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import Pagination from '@/components/component_astro_crick/pagination';
import { getImageUrl } from '@/lib/api';
import { sanitizeToText } from '@/lib/sanitize';
interface ImageMetadata {
  width?: number;
  height?: number;
  'focus-point'?: [number, number];
}
interface PhotoElement {
  id: string;
  title?: string;
  imageS3Key?: string;
  text?: string;
  imageMetadata?: ImageMetadata;
  attribution?: string;
}
interface HeroImage {
  imageS3Key: string;
  imageMetadata?: ImageMetadata;
  title?: string;
  attribution?: string;
}
interface PhotoCarouselProps {
  photos: PhotoElement[];
  heroImage?: HeroImage;
  maxHeight?: number;
  containerClassName?: string;
}
export default function PhotoCarousel(t0) {
  const $ = _c(42);
  const {
    photos,
    heroImage,
    maxHeight,
    containerClassName
  } = t0;
  const [currentPage, setCurrentPage] = useState(1);
  let handlePageChange;
  let t1;
  let t2;
  let t3;
  let t4;
  let totalPages;
  if ($[0] !== containerClassName || $[1] !== currentPage || $[2] !== heroImage || $[3] !== maxHeight || $[4] !== photos) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const storyImages = photos.filter(_temp);
      const allImages = [];
      if (heroImage?.imageS3Key) {
        allImages.push({
          id: "hero-image",
          title: heroImage.title,
          imageS3Key: heroImage.imageS3Key,
          imageMetadata: heroImage.imageMetadata,
          attribution: heroImage.attribution
        });
      }
      allImages.push(...storyImages);
      totalPages = allImages.length;
      const currentImage = allImages[currentPage - 1];
      let t5;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = page => {
          setCurrentPage(page);
        };
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      handlePageChange = t5;
      let t6;
      if ($[12] !== currentPage) {
        t6 = () => {
          if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
          }
        };
        $[12] = currentPage;
        $[13] = t6;
      } else {
        t6 = $[13];
      }
      const goToPrevious = t6;
      let t7;
      if ($[14] !== currentPage || $[15] !== totalPages) {
        t7 = () => {
          if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
          }
        };
        $[14] = currentPage;
        $[15] = totalPages;
        $[16] = t7;
      } else {
        t7 = $[16];
      }
      const goToNext = t7;
      const hasFocusPoint = _temp2;
      let t8;
      if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = metadata_0 => {
          if (!hasFocusPoint(metadata_0)) {
            return {};
          }
          const [focusX, focusY] = metadata_0["focus-point"];
          const xPercent = focusX / metadata_0.width * 100;
          const yPercent = focusY / metadata_0.height * 100;
          return {
            objectPosition: `${xPercent}% ${yPercent}%`
          };
        };
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      const getFocusPointStyle = t8;
      const getAspectRatio = _temp3;
      if (allImages.length === 0) {
        t4 = null;
        break bb0;
      }
      const metadata_2 = currentImage.imageMetadata;
      const showFocusedView = hasFocusPoint(metadata_2);
      getFocusPointStyle(metadata_2);
      getAspectRatio(metadata_2);
      t1 = "w-full";
      let t9;
      if ($[18] !== containerClassName || $[19] !== maxHeight) {
        t9 = !containerClassName && maxHeight ? {
          maxHeight: `${maxHeight}px`
        } : {};
        $[18] = containerClassName;
        $[19] = maxHeight;
        $[20] = t9;
      } else {
        t9 = $[20];
      }
      let t10;
      if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
          filter: "blur(20px)"
        };
        $[21] = t10;
      } else {
        t10 = $[21];
      }
      let t11;
      if ($[22] !== currentPage || $[23] !== goToPrevious || $[24] !== totalPages) {
        t11 = totalPages > 1 && <button onClick={goToPrevious} disabled={currentPage === 1} className={`absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black bg-opacity-50 hover:bg-opacity-70 transition-all ${currentPage === 1 ? "opacity-30 cursor-not-allowed" : "opacity-70 hover:opacity-100 cursor-pointer"}`} aria-label="Previous image"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="white" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg></button>;
        $[22] = currentPage;
        $[23] = goToPrevious;
        $[24] = totalPages;
        $[25] = t11;
      } else {
        t11 = $[25];
      }
      let t12;
      if ($[26] !== currentPage || $[27] !== goToNext || $[28] !== totalPages) {
        t12 = totalPages > 1 && <button onClick={goToNext} disabled={currentPage === totalPages} className={`absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black bg-opacity-50 hover:bg-opacity-70 transition-all ${currentPage === totalPages ? "opacity-30 cursor-not-allowed" : "opacity-70 hover:opacity-100 cursor-pointer"}`} aria-label="Next image"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="white" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg></button>;
        $[26] = currentPage;
        $[27] = goToNext;
        $[28] = totalPages;
        $[29] = t12;
      } else {
        t12 = $[29];
      }
      let t13;
      if ($[30] !== currentPage || $[31] !== totalPages) {
        t13 = totalPages > 1 && <div className="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-sm px-3 py-1 rounded-full">{currentPage} / {totalPages}</div>;
        $[30] = currentPage;
        $[31] = totalPages;
        $[32] = t13;
      } else {
        t13 = $[32];
      }
      t2 = <div className={`relative w-full group overflow-hidden ${containerClassName || ""}`} style={t9}><img src={getImageUrl(currentImage.imageS3Key)} alt="" className="absolute inset-0 w-full h-full object-cover blur-xl scale-110" style={t10} aria-hidden="true" />{showFocusedView ? <div className="relative w-full h-full" style={{
          aspectRatio: maxHeight ? undefined : "4 / 3",
          height: maxHeight ? "100%" : undefined
        }}><img src={getImageUrl(currentImage.imageS3Key)} alt={currentImage.title || `Photo ${currentPage}`} className="w-full h-full object-contain" style={{
            maxHeight: maxHeight ? `${maxHeight}px` : undefined
          }} loading="lazy" /></div> : <div className="relative w-full" style={{
          aspectRatio: maxHeight ? undefined : metadata_2?.width && metadata_2?.height ? `${metadata_2.width} / ${metadata_2.height}` : "16 / 9",
          maxHeight: maxHeight ? `${maxHeight}px` : undefined
        }}><img src={getImageUrl(currentImage.imageS3Key)} alt={currentImage.title || `Photo ${currentPage}`} className="w-full h-full object-contain" style={{
            maxHeight: maxHeight ? `${maxHeight}px` : undefined
          }} loading="lazy" /></div>}{t11}{t12}{t13}</div>;
      t3 = (currentImage.title || currentImage.text || currentImage.attribution) && <div className="bg-[#1a237e] p-4">{currentImage.title && <p className="text-white text-lg font-semibold mb-2">{sanitizeToText(currentImage.title)}</p>}{currentImage.text && <div className="text-white text-sm leading-relaxed" dangerouslySetInnerHTML={{
          __html: currentImage.text
        }} />}{currentImage.attribution && <p className="text-white text-sm text-right">{sanitizeToText(currentImage.attribution)}</p>}</div>;
    }
    $[0] = containerClassName;
    $[1] = currentPage;
    $[2] = heroImage;
    $[3] = maxHeight;
    $[4] = photos;
    $[5] = handlePageChange;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = totalPages;
  } else {
    handlePageChange = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    totalPages = $[10];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[33] !== currentPage || $[34] !== handlePageChange || $[35] !== totalPages) {
    t5 = totalPages > 1 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} scrollToTop={false} />;
    $[33] = currentPage;
    $[34] = handlePageChange;
    $[35] = totalPages;
    $[36] = t5;
  } else {
    t5 = $[36];
  }
  let t6;
  if ($[37] !== t1 || $[38] !== t2 || $[39] !== t3 || $[40] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t5}</div>;
    $[37] = t1;
    $[38] = t2;
    $[39] = t3;
    $[40] = t5;
    $[41] = t6;
  } else {
    t6 = $[41];
  }
  return t6;
}
function _temp3(metadata_1) {
  if (metadata_1?.width && metadata_1?.height) {
    return `${metadata_1.width} / ${metadata_1.height}`;
  }
  return "16 / 9";
}
function _temp2(metadata) {
  return !!(metadata?.["focus-point"] && metadata.width && metadata.height);
}
function _temp(photo) {
  return photo.imageS3Key;
}